var map = {
	"./de-DE.json": "6922",
	"./en-GB.json": "282d",
	"./en-US.json": "e0e1",
	"./es-ES.json": "4109",
	"./fr-FR.json": "cfe4",
	"./it-IT.json": "bf7d",
	"./nl-NL.json": "0727",
	"./pt-PT.json": "7b75"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "49f8";